import { ElMessageBox } from 'element-plus'
import 'element-plus/es/components/message-box/style/css'
// 定义 navigator.connection 的类型
interface NavigatorWithConnection extends Navigator {
  connection?: {
    effectiveType?: string
    addEventListener(
      type: string,
      listener: EventListenerOrEventListenerObject,
      options?: boolean | AddEventListenerOptions
    ): void
  }
  mozConnection?: {
    onLine?: string
    effectiveType?: string
    addEventListener(
      type: string,
      listener: EventListenerOrEventListenerObject,
      options?: boolean | AddEventListenerOptions
    ): void
  }
  webkitConnection?: {
    onLine?: string
    effectiveType?: string
    addEventListener(
      type: string,
      listener: EventListenerOrEventListenerObject,
      options?: boolean | AddEventListenerOptions
    ): void
  }
}

// 获取带有 connection 的 navigator 对象
const navigatorWithConnection = navigator as NavigatorWithConnection
let connection =
  navigatorWithConnection.connection ||
  navigatorWithConnection.mozConnection ||
  navigatorWithConnection.webkitConnection
console.log(connection?.effectiveType, navigator?.onLine)
// 弱网或者没网
let poorLineOrOffline = connection?.effectiveType === '2g' || !navigator?.onLine
if (poorLineOrOffline) {
  // 弹窗提示
  showMessageBox()
}
// 监听弱网
if (connection) {
  connection.addEventListener('change', () => {
    // connection.effectiveType返回的是具体的网络状态：4g/3g/2g
    // console.log(connection?.effectiveType)
    // 弹窗提示
    if (connection?.effectiveType === '2g') {
      showMessageBox()
    }
  })
}
// 监听没网
window.addEventListener('offline', () => {
  console.log('设备已断开网络连接')
  // 弹窗提示
  showMessageBox()
})

function showMessageBox() {
  ElMessageBox.confirm('当前您的网络状态不佳或者没有网络，请调整网络状态再进行操作', 'Warning', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {})
    .catch(() => {})
}
